// Copyright 2026 Linka Cloud  All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { AlternateEmailOutlined } from '@mui/icons-material';
import { Button, InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react';
import { useIsSubmitting } from '../hooks';

export interface EmailFormProps {
  submitLabel?: string;
  postUrl?: string;
  csrf?: string;
}

export const EmailForm = ({ submitLabel, postUrl, csrf }: EmailFormProps) => {
  const [isSubmitting, handleSubmit] = useIsSubmitting();
  const [email, _setEmail] = React.useState('');
  const [error, setError] = React.useState('');
  const validate = (value: string) => /(.+)@(.+){2,}\.(.+){2,}/.test(value);
  const setEmail = (value: string) => {
    if (validate(value)) {
      setError('');
    }
    _setEmail(value);
  };
  return (
    <Stack component="form" method="post" action={postUrl} onSubmit={handleSubmit}>
      <Stack>
        <TextField
          id="email"
          name="email"
          label="Email"
          type="email"
          error={!!error}
          helperText={error}
          placeholder="Enter your email"
          onBlur={() => validate(email) || setError('Please enter a valid email address')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <AlternateEmailOutlined />
                </InputAdornment>
              ),
            },
          }}
        />
      </Stack>
      <Stack direction="column">
        <Stack direction="row" spacing={4}>
          <Button fullWidth type="submit" variant="contained" disabled={isSubmitting || !email || !validate(email)}>
            {submitLabel ?? 'Reset Password'}
          </Button>
        </Stack>
      </Stack>
      <input hidden readOnly name="csrf" value={csrf} />
    </Stack>
  );
};
